export const RESET_REDUX = '@oldglory-web/logout/triggerLogout';

export const resetState = () => ({
    type: RESET_REDUX,
});
